export const title = 'Cumulative downloads (chart)';

Total app installs over time within the selected range.
